import { BaseReq } from "@/core/interface";

export enum UploadStatus {
  READY = "READY",
  UPLOADING = "UPLOADING",
  SUCCESS = "SUCCESS",
  FAIL = "FAIL",
}

export class FileRecord extends BaseReq {
  uid: string = "";
  name: string = "";
  url: string = "";
  size: number = 0;
  suffix: string = "";
  status: UploadStatus = UploadStatus.READY;
  bizId: string = "";
  bizType: string = "";
}

export class SignReq extends BaseReq {
  dir: string = ""; // 上传文件夹
  fileName: string = ""; // 文件名称(带后缀)
  source: string = "SAAS"; // 来源, CRM 或 SAAS
  path:string='';//请求路径
}


export class SignResp {
  policy: string = "";
  signature: string = "";
  dir: string = "";
  host: string = "";
  expire: string = "";
  callback: string = "";
  key: string = "";
  OSSAccessKeyId: string = "";
}
export interface StsAccount {
  accessKeyId: string,
  accessKeySecret: string,
  expiration: string,
  securityToken: string|undefined,
  bucketName?: string
}